import script from "./SearchGenericTermsToActivate.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchGenericTermsToActivate.vue?vue&type=script&setup=true&lang=js"

import "./SearchGenericTermsToActivate.vue?vue&type=style&index=0&id=6e3e5676&lang=css"

const __exports__ = script;

export default __exports__